import store from 'utils/store/withMiddleware'

function initStore(registry, middleware, initState) {
  store.setMiddleWare(middleware)
  store.registry(registry)
  store.update(initState)
}

export default initStore
